import { CatToggle } from '@blocks-react/components/Toggle';
import { CatSegmentedControl } from '@blocks-react/components/SegmentedControl';
import { CatIconList } from '@blocks-react/components/Icons/List';
import { CatIconMap } from '@blocks-react/components/Icons/Map';
import { CatSegmentedControlItem } from '@blocks-react/components/SegmentedControlItem';
import styles from '../DealerLocator.module.scss';
import cx from 'classnames';
import { Conditional } from '../../common';

interface DealerLocatorMapToggleProps {
  label: string;
  isChecked: boolean;
  setIsChecked: () => void;
  isDisabled?: boolean;
  isStoreLocationMapViewUpdateFlag?: boolean;
  listViewLabel?: string;
  mapViewLabel?: string;
  isMobile?: boolean;
}

export const DealerLocatorMapToggle = ({
  label,
  isChecked,
  setIsChecked,
  isDisabled,
  isStoreLocationMapViewUpdateFlag = false,
  listViewLabel = '',
  mapViewLabel = '',
  isMobile = false
}: DealerLocatorMapToggleProps) => {
  return (
    <>
      <Conditional test={!(isStoreLocationMapViewUpdateFlag && isMobile)}>
        <div className="d-flex align-items-center">
          <CatToggle
            checked={isChecked}
            label={label}
            hideLabel
            onBlToggleChange={setIsChecked}
            disabled={isDisabled}
          />
          <p
            className={cx(
              styles['dealer-locator-text'],
              'cat-u-theme-typography-label ps-2 mb-0'
            )}
          >
            {label}
          </p>
        </div>
      </Conditional>
      <Conditional test={isStoreLocationMapViewUpdateFlag && isMobile}>
        <CatSegmentedControl
          activeIndex={!isChecked ? 0 : 1}
          onBlSegmentItemChange={setIsChecked}
          className={cx(styles['segmented-controls'])}
        >
          <CatSegmentedControlItem>
            <CatIconList slot="before" className="me-1" />
            {listViewLabel}
          </CatSegmentedControlItem>
          <CatSegmentedControlItem>
            <CatIconMap slot="before" className="me-1" />
            {mapViewLabel}
          </CatSegmentedControlItem>
        </CatSegmentedControl>
      </Conditional>
    </>
  );
};
